import React from "react";
import {
  Search,
  Stethoscope,
  PenTool,
  Rocket,
  GraduationCap,
  Repeat,
  ShieldCheck,
  BarChart3,
  BadgeCheck,
  HeartHandshake,
  LineChart,
  Building2,
  Sparkles,
  Microscope,
  Leaf,
  FlaskConical,
  Settings2,
  Target,
  Workflow,
  Sprout,
  ClipboardCheck,
  Lightbulb,
  Route,
  Users,
  Cpu,
  Check,
  Hospital,
  HeartPulse,
  Pill,
  Circle,
} from "lucide-react";

const MAP = {
  Search,
  Stethoscope,
  PenTool,
  Rocket,
  GraduationCap,
  Repeat,
  ShieldCheck,
  BarChart3,
  BadgeCheck,
  HeartHandshake,
  LineChart,
  Building2,
  Sparkles,
  Microscope,
  Leaf,
  FlaskConical,
  Settings2,
  Target,
  Workflow,
  Sprout,
  ClipboardCheck,
  Lightbulb,
  Route,
  Users,
  Cpu,
  Check,
  Hospital,
  HeartPulse,
  Pill,
};

export default function Icon({ name, size = 20, className }) {
  const Cmp = MAP[name] || Circle;
  return <Cmp size={size} className={className} />;
}
